var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSchema } from "./components/ComponentRegistry.js";
import { F as FaceDirectionEnum, C as ComponentCategory } from "./enums-86f58524.js";
import { type, defaultValue, Component, Schema } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let SpriteSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "frame");
    __publicField(this, "framePadding");
    __publicField(this, "spriteKey");
    __publicField(this, "imageKey");
    __publicField(this, "currentAnimation");
    __publicField(this, "animationIndex");
    __publicField(this, "animationKey");
    __publicField(this, "animationSpeed");
    __publicField(this, "faceDirection");
    __publicField(this, "scale");
    __publicField(this, "initialScale");
    __publicField(this, "rotation");
    __publicField(this, "xoffset");
    __publicField(this, "yoffset");
    __publicField(this, "zIndex");
    __publicField(this, "inheritParentZIndex");
    __publicField(this, "relativeZIndex");
    __publicField(this, "opacity");
    __publicField(this, "anchorX");
    __publicField(this, "anchorY");
    __publicField(this, "antiJitterTime");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "frame", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "framePadding", 2);
__decorateClass([
  type("string")
], SpriteSchema.prototype, "spriteKey", 2);
__decorateClass([
  type("string")
], SpriteSchema.prototype, "imageKey", 2);
__decorateClass([
  type("string")
], SpriteSchema.prototype, "currentAnimation", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "animationIndex", 2);
__decorateClass([
  type("string")
], SpriteSchema.prototype, "animationKey", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "animationSpeed", 2);
__decorateClass([
  type("number"),
  defaultValue(FaceDirectionEnum.NONE)
], SpriteSchema.prototype, "faceDirection", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], SpriteSchema.prototype, "scale", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], SpriteSchema.prototype, "initialScale", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "rotation", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "xoffset", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "yoffset", 2);
__decorateClass([
  type("number"),
  defaultValue(0)
], SpriteSchema.prototype, "zIndex", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], SpriteSchema.prototype, "inheritParentZIndex", 2);
__decorateClass([
  type("boolean"),
  defaultValue(true)
], SpriteSchema.prototype, "relativeZIndex", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], SpriteSchema.prototype, "opacity", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], SpriteSchema.prototype, "anchorX", 2);
__decorateClass([
  type("number"),
  defaultValue(0.5)
], SpriteSchema.prototype, "anchorY", 2);
__decorateClass([
  type("boolean"),
  defaultValue(0)
], SpriteSchema.prototype, "antiJitterTime", 2);
SpriteSchema = __decorateClass([
  Component("Sprite")
], SpriteSchema);
registerSchema(ComponentCategory.RENDERING, SpriteSchema);
const __vite_glob_0_30 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get SpriteSchema() {
    return SpriteSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  SpriteSchema as S,
  __vite_glob_0_30 as _
};
//# sourceMappingURL=Sprite-7d2a5fa7.js.map
